import * as type from "./types"

export const fetchNewsList = () => {
    return { type: type.NEWS_LIST_REQUEST, payload: null }
}

export const resetNewsList = () => {
    return { type: type.RESET_NEWS_LIST, payload: null }
}

export const fetchNewsDetails = (slug) => {
    return { type: type.NEWS_DETAILS_REQUEST, payload: { slug } }
}

export const resetNewsDetails = () => {
    return { type: type.RESET_NEWS_DETAILS, payload: null }
}
